import React, { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { JSONTree } from "react-json-tree";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { registerChannel } from "../../api/channelApi";
import Swal from "sweetalert2";
import { IoCloseSharp } from "react-icons/io5";

interface ChannelRegistModalProps {
  isOpen: boolean;
  onClose: (state: boolean) => void;
  teamid: string | undefined;
  channelsSearch: () => void;
  teaminfo: TeamInfo;
}

interface TeamInfo {
  id: string;
  displayName: string;
  name: string;
  deleteAt: number;
  createAt: number;
  updateAt: number;
  memberCount: number;
}

const ChannelRegistModal: React.FC<ChannelRegistModalProps> = ({
  isOpen,
  onClose,
  teamid,
  channelsSearch,
  teaminfo,
}) => {
  const [channelName, setChannelName] = useState<string>("");
  const [channelDisplayName, setChannelDisplayName] = useState<string>("");
  const [channelIsPrivate, setChannelIsPrivate] = useState<boolean>(false);
  const [isAddAllMember, setIsAddAllMember] = useState<boolean>(false);

  const handleChannelAddModal = () => {
    onClose(false);
    setChannelIsPrivate(false);
    setIsAddAllMember(false);
    setChannelName("");
    setChannelDisplayName("");
  };

  const handleChannelName = (channelName: string) => {
    setChannelName(channelName);
  };

  const handleChannelDisplayName = (channelDisplayName: string) => {
    setChannelDisplayName(channelDisplayName);
  };

  const handleChannelIsPrivate = (channelIsPrivate: boolean) => {
    setChannelIsPrivate(channelIsPrivate);
  };

  const handleIsAddAllMember = () => {
    setIsAddAllMember(!isAddAllMember);
  };

  const registerCheck = () => {
    if (channelDisplayName.trim() === "") {
      alert("채널 이름을 입력해주세요.");
      return;
    } else if (!isValidChannelUrl(channelName)) {
      return;
    }

    channelRegister();
  };

  // 채널 생성
  const channelRegister = async () => {
    if (teamid) {
      const data = await registerChannel(teamid, channelName, channelDisplayName, channelIsPrivate, isAddAllMember);
      if (data) {
        channelsSearch();
        setChannelName("");
        setChannelDisplayName("");
        setChannelIsPrivate(false);
        setIsAddAllMember(false);
        registChannelSuccessAlert();
        console.log(data);
      } else {
        registChannelFailAlert();
      }
    }
  };

  const registChannelSuccessAlert = () => {
    Swal.fire({
      title: "성공",
      text: "채널 생성이 성공적으로 완료되었습니다.",
      icon: "success", // success, error, warning, info, question 중 선택 가능
      confirmButtonText: "확인",
      timer: 3000, // 알림이 자동으로 사라지는 시간 (ms)
      // timerProgressBar: true, // 타이머 진행 상태를 표시
    });
    handleChannelAddModal();
  };

  const registChannelFailAlert = () => {
    Swal.fire({
      title: "실패",
      text: "이미 존재하는 URL 입니다.",
      icon: "error", // success, error, warning, info, question 중 선택 가능
      confirmButtonText: "확인",
      timer: 3000, // 알림이 자동으로 사라지는 시간 (ms)
      // timerProgressBar: true, // 타이머 진행 상태를 표시
    });
  };

  // 채널널 생성 유효성 체크
  const isValidChannelUrl = (channelUrl: string): boolean => {
    // 정규표현식: 소문자, 숫자, 대시(-), 언더바(_), 마침표(.)만 포함
    const regex = /^[a-z0-9-_.]+$/;

    // 1. 정규표현식 검증
    if (!regex.test(channelUrl)) {
      alert("URL 규칙을 확인해주세요.");
      return false;
    }

    return true;
  };

  if (!isOpen) return null;

  return (
    <div>
      <div className="font-Noto_Sans_KR">
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-60 backdrop-blur-sm"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
            <div className="relative px-6 pt-6 pb-6 overflow-hidden text-left transition-all transform bg-white shadow-2xl rounded-xl sm:my-8 sm:w-full sm:max-w-lg">
              <div className="absolute top-0 right-0 pt-4 pr-4">
                <button
                  type="button"
                  className="text-gray-400 hover:text-gray-500"
                  onClick={() => {
                    handleChannelAddModal();
                  }}
                >
                  <span className="sr-only">닫기</span>
                  <IoCloseSharp />
                </button>
              </div>

              <div className="sm:flex sm:items-start">
                <div className="w-full mt-3 text-left sm:mt-0 sm:text-left">
                  <h3 className="mb-8 text-2xl font-bold leading-6 text-gray-900">채널 등록</h3>
                  <div className="flex items-center gap-2 mb-6 text-gray-600">
                    <i className="fas fa-users"></i>
                    <span>선택된 팀:</span>
                    <span className="font-medium text-gray-900">{teaminfo.displayName}</span>
                  </div>

                  <div className="space-y-7">
                    <div>
                      <label htmlFor="course-name" className="block text-sm font-medium leading-6 text-gray-900 ">
                        채널명
                      </label>
                      <div className="mt-2 border black">
                        <input
                          type="text"
                          id="course-name"
                          // required=""
                          className="block w-full p-2"
                          placeholder="채널명을 입력하세요"
                          value={channelDisplayName}
                          onChange={(e) => handleChannelDisplayName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="course-url" className="block text-sm font-medium leading-6 text-gray-900 ">
                        채널 URL
                      </label>
                      <div className="mt-2 border black">
                        <input
                          type="text"
                          id="course-url"
                          // required=""
                          className="block w-full p-2"
                          placeholder="채널 URL 을 입력하세요"
                          value={channelName}
                          onChange={(e) => handleChannelName(e.target.value)}
                        />
                      </div>
                      <p className="mt-1 text-sm text-red-400">
                        * 소문자, 숫자, 마침표, 대시 및 밑줄만 사용할 수 있습니다.
                      </p>
                    </div>
                    <div className="mt-6">
                      <label className="block mb-2 text-sm font-medium leading-6 text-gray-900">채널 유형</label>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center">
                          <label
                            className={`flex items-center justify-center w-16 h-16 border rounded-full cursor-pointer 
                                ${!channelIsPrivate ? "bg-blue-500 text-white" : "bg-gray-200"}`}
                          >
                            <input
                              type="checkbox"
                              value="public"
                              checked={!channelIsPrivate}
                              onChange={() => handleChannelIsPrivate(false)}
                              className="hidden"
                            />
                            일반
                            <br />
                            채널
                          </label>
                        </div>
                        <div className="flex items-center">
                          <label
                            className={`flex items-center justify-center w-16 h-16 border rounded-full cursor-pointer ${
                              channelIsPrivate ? "bg-blue-500 text-white" : "bg-gray-200"
                            }`}
                          >
                            <input
                              type="checkbox"
                              value="private"
                              checked={channelIsPrivate}
                              onChange={() => handleChannelIsPrivate(true)}
                              className="hidden"
                            />
                            잠긴
                            <br />
                            채널
                          </label>
                        </div>
                      </div>
                      <p className="mt-1 text-sm text-gray-500">잠긴 채널은 초대받은 멤버만 접근할 수 있습니다.</p>
                    </div>
                    <div className="mt-6">
                      <label className="block mb-2 text-sm font-medium leading-6 text-gray-900">팀원 전체 등록</label>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id="allAdd"
                            name="allMember"
                            value="public"
                            className="w-4 h-4 border-gray-300 text-custom focus:ring-custom"
                            checked={isAddAllMember}
                            onChange={() => {
                              handleIsAddAllMember();
                            }}
                          />
                          <label htmlFor="public-channel" className="ml-2 text-sm text-gray-900">
                            전체 등록
                          </label>
                        </div>
                      </div>
                      <p className="mt-1 text-sm text-gray-500">모든 팀원을 채널에 등록할지 선택합니다.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="gap-3 mt-8 sm:flex sm:flex-row-reverse">
                <button
                  onClick={() => {
                    registerCheck();
                  }}
                  className="inline-flex w-full justify-center rounded-lg bg-black px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-custom/90 sm:w-auto transition-all duration-200"
                >
                  채널 생성하기
                </button>
                <button
                  onClick={() => {
                    handleChannelAddModal();
                  }}
                  className="inline-flex w-full justify-center rounded-lg bg-white px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto transition-all duration-200"
                >
                  취소
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelRegistModal;
